export default __webpack_public_path__ + "static/media/Menu-sidebar.3c2b7dc0.svg";